import { render, staticRenderFns } from "./GenericOffers.vue?vue&type=template&id=72798ce2"
import script from "./GenericOffers.vue?vue&type=script&lang=js"
export * from "./GenericOffers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports